/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import sbp from '@sbp/sbp'
import { mapState, mapGetters } from 'vuex'
import { OPEN_MODAL } from '../../../../frontend/utils/events.js'
import ModalClose from '../../../../frontend/views/components/modal/ModalClose.vue'
import Tooltip from '../../../../frontend/views/components/Tooltip.vue'
import NotificationList from './NotificationList.vue'

const __vue_script__ = {
  name: 'NotificationCard',
  components: {
    ModalClose,
    NotificationList,
    Tooltip
  },
  methods: {
    toggleTooltip () {
      this.$refs.tooltip.toggle()
    },
    handleSettingsClick () {
      // BUG - Section notification does not open. Fixed at #946
      sbp('okTurtles.events/emit', OPEN_MODAL, 'UserSettingsModal', {
        tab: 'notifications'
      })
      this.toggleTooltip()
    },
    markAllNotificationsAsRead () {
      sbp('gi.notifications/markAllAsRead', this.currentGroupId)
    }
  },
  computed: {
    ...mapState([
      'currentGroupId'
    ]),
    ...mapGetters([
      'currentNotificationCount'
    ])
  }
}

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tooltip',{ref:"tooltip",attrs:{"direction":"right","manual":true,"opacity":1,"aria-label":_vm.L("Show notifications")}},[_vm._t("default"),_c('template',{slot:"tooltip"},[_c('div',{staticClass:"card c-card",attrs:{"role":"dialog","aria-label":_vm.L("Notifications"),"data-test":"notificationCard"}},[_c('div',{staticClass:"c-header"},[_c('i18n',{staticClass:"is-title-4",attrs:{"tag":"h2"}},[_vm._v("Notifications")]),_c('button',{staticClass:"is-icon-small c-settings-btn",on:{"click":_vm.handleSettingsClick}},[_c('i',{staticClass:"icon-cog"})])],1),_c('div',{staticClass:"c-body"},[_c('notification-list',{attrs:{"variant":"compact"},on:{"select":_vm.toggleTooltip}})],1),(_vm.currentNotificationCount)?_c('div',{staticClass:"c-footer"},[_c('i18n',{staticClass:"link",attrs:{"tag":"button","data-test":"markAllAsRead_In_Tooltip"},on:{"click":_vm.markAllNotificationsAsRead}},[_vm._v("Mark all as read")]),_c('router-link',{staticClass:"link",attrs:{"to":{ query: { modal: "NotificationModal" }}},nativeOn:{"click":function($event){return _vm.toggleTooltip($event)}}},[_c('i18n',[_vm._v("See all")])],1)],1):_vm._e(),_c('modal-close',{staticClass:"c-close",attrs:{"aria-label":_vm.L("Close profile")},on:{"close":_vm.toggleTooltip}})],1)])],2)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-32fe52eb_0", { source: ".c-card[data-v-32fe52eb]{position:relative;padding:0 0 4rem;color:var(--text_0);max-width:100vw;border-radius:3px;width:100vw;box-shadow:none}.c-card[data-v-32fe52eb]:last-child{margin-bottom:0}.is-active .c-card[data-v-32fe52eb]{animation:zoom .1s both cubic-bezier(.165,.84,.44,1)}@media screen and (max-width:768px){.is-active .c-card[data-v-32fe52eb]{animation-name:enterFromBottom}}@media screen and (min-width:769px),print{.c-card[data-v-32fe52eb]{margin-top:-.5rem;box-shadow:0 .5rem 1.25rem rgba(54,54,54,.3);width:25rem;padding:0}.c-card[data-v-32fe52eb]::before{content:\"\";position:absolute;top:1rem;left:-.5rem;display:block;width:0;z-index:0;border-top:.5rem solid transparent;border-right:.5rem solid var(--background_0);border-bottom:.5rem solid transparent}}.c-close[data-v-32fe52eb]{left:calc(100vw - 4rem);top:1.5rem}@media screen and (min-width:769px),print{.c-close[data-v-32fe52eb]{left:auto;right:1rem;opacity:0;pointer-events:none}.c-close[data-v-32fe52eb]:focus{opacity:1}}.c-footer[data-v-32fe52eb],.c-header[data-v-32fe52eb]{display:flex;justify-content:space-between;align-items:center}.c-header[data-v-32fe52eb]{padding:1rem 1rem .5rem}.c-footer[data-v-32fe52eb]{border-top:1px solid var(--general_1);padding:.75rem 1rem}.c-body[data-v-32fe52eb]{height:18rem;overflow:auto;overscroll-behavior-y:contain}.c-settings-btn .icon-cog[data-v-32fe52eb]{transform-origin:49% 48%}.c-settings-btn:focus .icon-cog[data-v-32fe52eb],.c-settings-btn:hover .icon-cog[data-v-32fe52eb]{animation:cog-data-v-32fe52eb .4s forwards}@keyframes cog-data-v-32fe52eb{to{transform:rotate(180deg)}}", map: undefined, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-32fe52eb"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "style>\n"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (true && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__